import { ReviewServiceType } from 'common/types/entities/api/review'

enum OrderServiceType {
  CHECKOUT = 'CHECKOUT',
  MP = 'MP',
  C3 = 'C3',
}

namespace OrderServiceType {
  const values = {
    CHECKOUT: {
      name: '네이버페이',
      reviewWritable: true,
      reviewServiceType: ReviewServiceType.CHECKOUT,
    },
    MP: {
      name: '스마트스토어',
      reviewWritable: true,
      reviewServiceType: ReviewServiceType.SELLBLOG,
    },
    C3: {
      name: '안전결제',
      reviewWritable: false,
      reviewServiceType: null,
    },
  }

  export const getName = (type: OrderServiceType): string => {
    return values[type] && values[type].name
  }

  export const isReviewWritable = (type: OrderServiceType): boolean => {
    return values[type] && values[type].reviewWritable
  }

  /**
   * Order 의 서비스 타입과 매칭되는 Review 의 서비스 타입 반환
   * @param type
   */
  export const getReviewServiceType = (type: OrderServiceType): ReviewServiceType => {
    return values[type] && values[type].reviewServiceType
  }
}

export default OrderServiceType
